import { getAuthenticationState, getProject } from "@/graphql/queries";
import { encodeCollection } from "@/graphql/mutations";
import timeago from 'epoch-timeago';

export const currentProject = {
  apollo: {
    authenticationState: getAuthenticationState,
    project: {
        query: getProject,
        variables() {
            return {
                input: {
                    projectId: this.authenticationState.selectedProject
                }
            }
        },
        skip() {
            return this.$apollo.queries.authenticationState.loading || this.$apollo.queries.authenticationState.error;
        }
    },
  },
  data () {
    return {
      isProcessingEncoding: false
    }
  },
  watch: {
    encoding: {
      handler: 'togglePolling',
      immediate: true
    },
    syncing: {
      handler: 'togglePolling',
      immediate: true
    },
    deploying : {
      handler: 'togglePolling',
      immediate: true
    }
  },
  methods: {
    togglePolling (value) {
    
      if (this.$apollo.queries.project) {
        if (value) {

          this.$apollo.queries.project.startPolling(2000);

        } else {
          this.$apollo.queries.project.stopPolling();
        }
      }
    },
    async encodeCollection () {
        if (this.isProcessingEncoding) {
          return
        }

        this.isProcessingEncoding = true;

        this.$root.$emit('loading', true);
        try {

            await this.$apollo.mutate({
                mutation: encodeCollection,
                variables: {
                    input: {
                        projectId: this.currentProjectId,
                        collectionId: this.currentCollectionId
                    }
                }
            });

            this.$router.push({ name: 'CollectionPage', params: { collectionId: this.$route.params.collectionId }});

        } catch (error) {
            this.handleError(error);
        }
        this.$root.$emit('loading', false);
        this.isProcessingEncoding = false;


    },
  },
  computed: {
      currentProject () {
         return this.project ? this.project.project : null;
      },
      currentProjectId () {
         return this.project ? this.project.project.id : null;
      },
      activeModels () {
        return this.currentProject ? this.currentProject.models.filter(model => !model.archived) : [];
      },
      inactiveModels () {
        return this.currentProject ?  this.currentProject.models.filter(model => model.archived) : [];
      },
      deployedModels () {
          return this.currentProject ? this.activeModels.filter(model => model.status === 'deployed') : [];
      },
      activeCollections () {
        return this.currentProject ? this.currentProject.collections.filter(collection => !collection.archived) : [];
      },
      inactiveCollections () {
        return this.currentProject ?  this.currentProject.collections.filter(collection => collection.archived) : [];
      },
      currentModel () {
        const modelId = this.$route.params.modelId || this.$route.query.modelId || (this.activeModels[0] ? this.activeModels[0].id : null);

        const model = modelId && this.currentProject ? this.currentProject.models.find(model => model.id === modelId) : null;

        if (model) {
          return { active: !model.archived, ...model };
        } else {
          return null;
        }
      },
      currentModelId () {
        return this.currentModel ? this.currentModel.id : null;
      },
      currentCollection () {
        const collectionId = this.$route.params.collectionId || this.$route.query.collectionId || (this.activeCollections[0] ? this.activeCollections[0].id : null);

        const collection = collectionId && this.currentProject ? this.currentProject.collections.find(collection => collection.id === collectionId) : null;

        if (collection) {
          return { active: !collection.archived, ...collection };
        } else {
          return null;
        }

      },
      currentCollectionId () {
        return this.currentCollection ? this.currentCollection.id : null;
      },
      currentCollectionIndex () {
        return this.currentCollection ? this.currentCollection.index : null;
      },
      syncing () {
        return this.currentCollection ? this.currentCollection.syncing : false;
      },
      encoding () {
        return this.currentCollection ? this.currentCollection.encoding : false;
      },
      changed () {
        return this.currentCollection ? this.currentCollection.changed : false;
      },
      deploying () {
        return this.currentModel ? (this.currentModel.status !== 'created' && this.currentModel.status !== 'deployed' && this.currentModel.status !== 'failed') : false
      },
      searchableFields() {
        return this.currentCollection ? this.currentCollection.searchableFields : [];
      },
      teamMembers () {
        if(this.currentProject) {
          return this.currentProject.team.map(member => {
            return { role: member.role, ...member.user  };
          });
        } else {
          return []
        }
      },
      pendingInvites () {
        return this.currentProject.invites.filter(invite => invite.status === 'invited');
      },
      myRole() {
        return this.teamMembers.reduce((role, member) => {

            if (member.id === this.authenticationState.uid) {
              role = member.role;
            }

            return role;
        }, "member");
      },
      isOwner() {
        return this.myRole === 'owner'
      },
      lastEncoded () {
        return this.currentCollection && this.currentCollection.encodedAt ? timeago(this.currentCollection.encodedAt) : 'never';
      }
  }
};
